import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GrnService } from 'src/app/services/grn/grn.service';
import { GrnHeader } from 'src/app/model/grnHeader.model';
import { GrnLine } from 'src/app/model/grnLine.model';

@Component({
  selector: 'app-grnform',
  templateUrl: './grnform.component.html',
  styleUrls: ['./grnform.component.css']
})
export class GrnformComponent implements OnInit {

  id: number;
  purchaseData: any;
   grnHeader: GrnHeader[];

  // data: GrnLine[];
  data:any;
  grandTotal : number;
  vendorGrnLine:any;

  constructor(private router: Router, private route: ActivatedRoute,
    private engineeringServices: GrnService) {
    this.id = this.route.snapshot.params.id;
    // alert(this.id);
  }

  ngOnInit() {
    this.getOrderById();
  }

  getOrderById() {
    debugger;

    // var lineTotal = 0;
    // this.grandTotal = 0;
    this.engineeringServices.GetGrnLineListById(this.id).subscribe(
      (data:any) => {
        debugger;
        this.purchaseData = data;
        console.log(this.purchaseData);
        debugger;
         this.grnHeader = this.purchaseData;

         debugger;
       //this.data =this.grnHeader;

        // for(var i=0; i<this.data.length;i++)
        // {
        //   var unicost = this.data[i].unitCost;
        //   unicost = unicost.replace(/\,/g,'');
        //   this.data[i].unitCost = unicost;

        //   var quantty = this.data[i].quantity;
        //   quantty = quantty.replace(/\,/g,'');
        //   this.data[i].quantity = quantty;

        //   lineTotal = parseInt(unicost) * parseInt(quantty);
        //   this.grandTotal = this.grandTotal + lineTotal;
        // }

        // console.log(this.purchaseHeader);
      }
    )
  }

}
